import {
  isOwnerOrAdministrator,
  paths,
  selectCurrentUserRole,
  useAppSelector,
  useMerchantQry
} from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { NavLink } from 'react-router-dom'

interface Props {
  onHideMenu?: () => void
}

function MainMenuItems({ onHideMenu }: Props) {
  const customerRole = useAppSelector(selectCurrentUserRole)
  const { merchant } = useMerchantQry()
  const isReferralVisible = isOwnerOrAdministrator(customerRole) && merchant?.capabilities?.allowReferrals

  return (
    <>
      <NavLink activeClassName='active-tab' to={paths.dashboard()} onClick={onHideMenu}>
        {tr('PORTAL.HEADER.OVERVIEW', 'Overview')}
      </NavLink>

      <NavLink activeClassName='active-tab' to={paths.banking.accounts.list()} onClick={onHideMenu}>
        {tr('PORTAL.HEADER.ACCOUNTS', 'Accounts')}
      </NavLink>
      <NavLink activeClassName='active-tab' to={paths.banking.transactions.list()} onClick={onHideMenu}>
        {tr('PORTAL.HEADER.TRANSACTIONS', 'Transactions')}
      </NavLink>
      <NavLink activeClassName='active-tab' to={paths.banking.expenses()} onClick={onHideMenu}>
        {tr('PORTAL.HEADER.EXPENSES', 'Expenses')}
      </NavLink>
      <NavLink activeClassName='active-tab' to={paths.invoices.list()} onClick={onHideMenu}>
        {tr('PORTAL.HEADER.INVOICES', 'Invoices')}
      </NavLink>
      {isReferralVisible && (
        <NavLink activeClassName='active-tab' to={paths.referralProgram()} onClick={onHideMenu}>
          {tr('PORTAL.HEADER.REFERRAL', 'Invite & Earn')}
        </NavLink>
      )}
    </>
  )
}

export default MainMenuItems
